export const initialState = {
  loading: false,
  error: null,
  loggedin: true,
  username: "",
  groups: [],
  users: [],
  markets: [],
  configData: {},
  optimizerRefresh: false,
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const salesrepReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_ANY_USER_STATE":
      return Object.assign({}, state, action.payload);
    case "LOGIN_USER":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_USER":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_CONFIG_DATA":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_CONFIG_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        configData: action.payload,
      };
    case "GET_CONFIG_DATA_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_FUTURE_EMPLOYER":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "LOGOUT_USER":
      return {
        ...state,
        loggedin: false,
        username: "",
        groups: [],
      };
    case "FETCH_USERS_SUCCESS":
      return {
        ...state,
        users: action.payload.credentials,
        markets: action.payload.markets,
        error: "",
      };
    case "FETCH_USERS_FAIL":
      return { ...state, users: [], error: action.payload };
    // case FETCH_SALES_REP_RECORDS_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: null,
    //     sales_rep: action.payload.data,
    //   };
    // case FETCH_SALES_REP_RECORDS_FAILURE:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: action.payload,
    //   };
    default:
      return state;
  }
};

export default salesrepReducer;
